export default __webpack_public_path__ + "static/media/satellites.c7262227.png";